// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".screen[data-v-0fd3cf7e]{position:relative}.screen-header[data-v-0fd3cf7e]:empty{display:none}.screen-content[data-v-0fd3cf7e]{padding:0 0 10px;width:100%}.screen-footer[data-v-0fd3cf7e]:empty{display:none}.screen--light .screen-header[data-v-0fd3cf7e]{background-color:var(--c-white);padding-top:15px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
